import React, { useEffect, useState } from 'react';
import './age.css';

function ZoneCard({ label, value, accent }) {
  return (
    <div className="zone-card" style={{ '--accent': accent }}>
      <div className="zone-label">{label}</div>
      <div className="zone-value">{value}</div>
    </div>
  );
}

function Age({ onBpmChange, resetSignal }) {
  const [age, setAge] = useState('');
  const [error, setError] = useState('');
  const [zones, setZones] = useState(null);

  useEffect(() => {
    if (resetSignal === undefined) return;
    setAge('');
    setError('');
    setZones(null);
  }, [resetSignal]);

  const calculate = (e) => {
    e?.preventDefault?.();
    const parsed = parseInt(age, 10);
    if (!age || isNaN(parsed) || parsed <= 0 || parsed > 120) {
      setError('Please enter a valid age between 1 and 120.');
      setZones(null);
      return;
    }
    setError('');
    const maxHR = 220 - parsed;
    const mod = [Math.round(maxHR * 0.64), Math.round(maxHR * 0.76)];
    const vig = [Math.round(maxHR * 0.77), Math.round(maxHR * 0.93)];
    setZones({ maxHR, mod, vig });
    if (onBpmChange) {
      onBpmChange(Math.round((mod[0] + mod[1]) / 2));
    }
  };

  return (
    <section className="age-section">
      <form className="age-form" onSubmit={calculate}>
        <label htmlFor="age-input" className="age-label">
          Enter your age
        </label>
        <div className="age-input-row">
          <input
            id="age-input"
            type="number"
            value={age}
            onChange={(e) => setAge(e.target.value)}
            placeholder="e.g. 28"
            min="1"
            max="120"
          />
          <button type="submit" className="calc-btn">
            Calculate
          </button>
        </div>
        {error && <div className="age-error">{error}</div>}
      </form>

      {zones && (
        <div className="zones-grid">
          <ZoneCard label="Max Heart Rate" value={`${zones.maxHR} bpm`} accent="#f01e02" />
          <ZoneCard
            label="Moderate Intensity"
            value={`${zones.mod[0]} – ${zones.mod[1]} bpm`}
            accent="#ff8c42"
          />
          <ZoneCard
            label="Vigorous Intensity"
            value={`${zones.vig[0]} – ${zones.vig[1]} bpm`}
            accent="#ffd23f"
          />
        </div>
      )}
    </section>
  );
}

export default Age;
